import qs from 'qs';
import Pagination from 'core/models/pagination';
import ManifestoMdfe from 'core/models/FRO/manifestoMdfe';
import ManifestoCTE from 'core/models/FRO/manifestoCTE';
import api from '../api';

const baseURL = `/FRO/ManifestoMdfe`;

export const getManifestoMdfeList = async (filters) => {
  const response = await api.get(`${baseURL}/Search`, {
    params: filters,
  });
  const { status, message, value } = response.data ?? {};

  return {
    status,
    message,
    data: value?.map((json) => new ManifestoMdfe(json)) ?? [],
  };
};

export const getManifestoMdfePagined = async (filters) => {
  const response = await api.get(`${baseURL}/SearchPagined`, {
    params: filters,
  });
  const { status, message, value, pagination } = response.data ?? {};

  return {
    status,
    message,
    data: value?.map((json) => new ManifestoMdfe(json)) ?? [],
    pagination: new Pagination(pagination),
  };
};

export const getManifestoMdfe = async (id) => {
  const response = await api.get(`${baseURL}/`, {
    params: { id },
  });
  const { value } = response.data ?? {};
  return value ? new ManifestoMdfe(value) : {};
};

export const saveManifestoMdfe = async (data) => {
  const response = await api.post(`${baseURL}/`, data);
  return response.data ?? {};
};

export const deleteManifestoMdfe = async (id) => {
  const response = await api.delete(`${baseURL}/`, { params: { id } });
  return response.data ?? {};
};

export const printManifestoMdfe = async (filters) => {
  const response = await api.get(`${baseURL}/Print`, {
    params: filters,
  });
  return response.data ?? {};
};

export const excelManifestoMdfe = async (filters) => {
  const response = await api.get(`${baseURL}/Excel`, {
    params: filters,
  });
  return response.data ?? {};
};

export const deleteAllManifestoMdfe = async (ids) => {
  const response = await api.delete(`${baseURL}/DeleteAll`, {
    params: { ids },
    paramsSerializer: (params) => qs.stringify(params),
  });
  return response.data ?? {};
};

export const efetivarMdfe = async (data) => {
  const response = await api.post(`${baseURL}/EffectMdfe`, data);

  const { status, message, value } = response.data ?? {};

  return {
    status,
    message,
    value: new ManifestoCTE(value ?? {}),
  };
};

export const cancelarMdfe = async (data) => {
  const response = await api.post(`${baseURL}/CancelMdfe`, data);

  const { status, message, value } = response.data ?? {};

  return {
    status,
    message,
    value: value ?? {},
  };
};

export const closeMdfe = async (data) => {
  const response = await api.post(`${baseURL}/CloseMdfe`, data);

  const { status, message, value } = response.data ?? {};

  return {
    status,
    message,
    data: value ?? {},
  };
};

export const encerrarMultiplosMdfes = async (data) => {
  const response = await api.post(`${baseURL}/EncerrarMultiplosMdfes`, data);

  const { status, message, value } = response.data ?? {};

  return {
    status,
    message,
    data: value ?? {},
  };
};

export const alteraManifestoParaOffline = async (data) => {
  const response = await api.post(
    `${baseURL}/AlteraManifestoParaOffline`,
    data
  );

  const { status, message } = response.data ?? {};

  return {
    status,
    message,
  };
};
